import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import AdminDashboard from '../../components/templates/admin/AdminDashboard';

const AdminDashboardPage = () => {
  return (
    <AdminLayout>
      <AdminDashboard />
    </AdminLayout>
  );
};

export default AdminDashboardPage;
